import React from 'react';
import PropTypes from 'prop-types';

import {
  StepsStyled,
  Step,
  StepContent,
  NumberStep,
  IconStyled,
} from './Steps.styled';

function Steps({ className, stepName, dataSteps, stepActive }) {
  return (
    <StepsStyled
      className={className}
      stepActive={stepActive}
      totalSteps={dataSteps.length}
    >
      {dataSteps.map((step, index) => (
        <Step key={index} isActive={index + 1 <= stepActive}>
          <StepContent
            isActive={index + 1 <= stepActive}
            isValidated={index + 1 < stepActive}
          >
            <NumberStep>
              {stepName} {index + 1}
              <IconStyled
                name='check'
                size='xsmall'
                customStroke='bold'
                isVisible={index + 1 < stepActive}
              />
            </NumberStep>
            {step}
          </StepContent>
        </Step>
      ))}
    </StepsStyled>
  );
}

export default Steps;

Steps.propTypes = {
  className: PropTypes.string,
  stepName: PropTypes.string,
  dataSteps: PropTypes.array.isRequired,
  stepActive: PropTypes.number,
};
